import {
    Box,
    Divider,
    Grid,
    Snackbar,
    TextField,
    Typography
} from "@material-ui/core";
import MuiAlert from "@material-ui/lab/Alert";
import { useEffect, useState } from "react";

import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody";
import CardHeader from "components/Card/CardHeader";
import CardIcon from "components/Card/CardIcon";
import Button from "components/CustomButtons/Button";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";

import { Stack } from "@mui/material";
import CustomInput from "components/CustomInput/CustomInput";
import CustomSelect from "components/CustomSelect/CustomSelect";
import createPayment from "services/PaymentService/createPayment";
import getPaymentSummary from "services/PaymentService/getPaymentSummary";

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}
const paymentModeOptions = [
    { id: "Cash", name: "Cash" },
    { id: "UPI", name: "UPI" },
    { id: "Card", name: "Card" },
    { id: "NetBanking", name: "Net Banking" },
    { id: "Cheque", name: "Cheque" },
];

const today = new Date().toISOString().split("T")[0];


export default function AddPaymentModal({ enquiry, onClose, onSuccess }) {
    const [paymentSuccess, setPaymentSuccess] = useState(null);

    const [paymentData, setPaymentData] = useState({
        userId: enquiry?.convertedUserId,
        programId: enquiry?.programId,
        amount: "",
        paymentMode: "Cash",
        transactionId: "",
        paymentDate: new Date().toISOString().slice(0, 10),
        // totalFee: enquiry?.totalFee ?? 0,
        createdBy: "system"
    });

    const [summary, setSummary] = useState({
        totalFee: 0,
        totalPaid: 0,
        remainingAmount: 0,
        expectedByNow: 0,
        overdueAmount: 0,
        nextExpectedAmount: 0,
        nextExpectedDate: null
    });


    const [open, setOpen] = useState(false);
    const [severity, setSeverity] = useState("success");
    const [message, setMessage] = useState("");

    useEffect(() => {
        fetchSummary();
    }, []);

    const fetchSummary = async () => {
        const res = await getPaymentSummary(enquiry.convertedUserId, enquiry.programId);
        if (res) {
            setSummary(res);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setPaymentData({ ...paymentData, [name]: value });
    };

    const showSnack = (msg, sev) => {
        setSeverity(sev);
        setMessage(msg);
        setOpen(true);
    };

    const handleSubmit = async () => {
        if (!paymentData.amount || paymentData.amount <= 0) {
            showSnack("Enter valid amount", "error");
            return;
        }

        if (paymentData.amount > summary.remainingAmount) {
            showSnack("Amount exceeds remaining balance", "error");
            return;
        }

        const date = new Date(paymentData.paymentDate);
        const now = new Date();

        date.setHours(
            now.getHours(),
            now.getMinutes(),
            now.getSeconds(),
            now.getMilliseconds()
        );
        const payload = {
            ...paymentData,
            paymentDate: date?.toISOString(),
            amount: Number(paymentData.amount),
        };

        const res = await createPayment(payload);

        if (res) {
            const paidAmount = Number(paymentData.amount);
            const newRemaining = summary.remainingAmount - paidAmount;

            setPaymentSuccess({
                paidAmount,
                remaining: newRemaining,
                date: paymentData.paymentDate,
                mode: paymentData.paymentMode,
                transactionId: paymentData.transactionId
            });

            return; // stop further execution
        }
        else {
            showSnack("Payment failed", "error");
        }
    };
    // helpers

    const getTransactionLabel = () => {
        switch (paymentData.paymentMode) {
            case "UPI":
                return "UPI Reference No";
            case "Cheque":
                return "Cheque No";
            case "Card":
                return "Card Transaction ID";
            case "NetBanking":
                return "Bank Transaction ID";
            default:
                return "Transaction ID";
        }
    };

    if (paymentSuccess) {
        return (
            <Card style={{ textAlign: "center", padding: "25px 10px" }}>
                <CardBody>

                    <div style={{ marginBottom: 20 }}>
                        <i
                            className="material-icons"
                            style={{ fontSize: 60, color: "#16a34a" }}
                        >
                            check_circle
                        </i>
                    </div>

                    <Typography variant="h5" style={{ fontWeight: 600 }}>
                        Payment Successful
                    </Typography>

                    {/* <Typography
                        variant="body1"
                        style={{ marginTop: 15, color: "#555" }}
                    >
                        Thank you for your payment.
                    </Typography> */}

                    <Box mt={8} style={{ maxWidth: 400, margin: "0 auto" }}>
                        <Divider style={{ margin: "20px 0" }} />
                        <Box display="flex" justifyContent="space-between" mb={1}>
                            <Typography><b>Amount Paid:</b></Typography>
                            <Typography>₹{paymentSuccess.paidAmount.toLocaleString()}</Typography>
                        </Box>

                        <Box display="flex" justifyContent="space-between" mb={1}>
                            <Typography><b>Payment Mode:</b></Typography>
                            <Typography>{paymentSuccess.mode}</Typography>
                        </Box>

                        <Box display="flex" justifyContent="space-between" mb={1}>
                            <Typography><b>Date:</b></Typography>
                            <Typography>
                                {new Date(paymentSuccess.date).toLocaleDateString()}
                            </Typography>
                        </Box>

                        {paymentSuccess.transactionId && (
                            <Box display="flex" justifyContent="space-between" mb={1}>
                                <Typography><b>Transaction ID:</b></Typography>
                                <Typography>{paymentSuccess.transactionId}</Typography>
                            </Box>
                        )}

                        <Divider style={{ margin: "20px 0" }} />
                    </Box>


                    <Button
                        color="rose"
                        onClick={() => {
                            onSuccess();
                            onClose();
                        }}
                    >
                        Close
                    </Button>

                </CardBody>
            </Card>
        );
    }

    return (
        <Card>
            <CardHeader color="rose" icon>
                <CardIcon color="rose">
                    <i className="material-icons">payments</i>
                </CardIcon>
                <h4 style={{ color: '#000000' }}>Add Payment ( Optional )</h4>
            </CardHeader>

            <CardBody>
                <GridContainer spacing={2}>

                    {/* Summary */}
                    {/* <GridItem xs={12}>
                        <div style={{ marginBottom: 15 }}>
                            <b>Total Fee:</b> ₹{summary.totalFee}<br />
                            <b>Total Paid:</b> ₹{summary.totalPaid}<br />
                            <b>Remaining:</b> ₹{summary.remainingAmount}<br />
                            <b>Expected By Now:</b> ₹{summary.expectedByNow}<br />
                            {summary.nextExpectedAmount > 0 && (
                                <div style={{ marginTop: 8, color: "#555" }}>
                                    <b>Next Due:</b> ₹{summary.nextExpectedAmount}
                                    {summary.nextExpectedDate && (
                                        <> by {new Date(summary.nextExpectedDate).toLocaleDateString()}</>
                                    )}
                                </div>
                            )}

                            {summary.overdueAmount > 0 && (
                                <span style={{ color: "red" }}>
                                    <b>Overdue:</b> ₹{summary.overdueAmount}
                                </span>
                            )}
                        </div>
                    </GridItem>
 */}
                    <GridItem xs={12}>
                        <Box
                            sx={{
                                borderRadius: 3,
                                p: 3,
                                backgroundColor: "#ffffff",
                                border: "1px solid #eee",
                            }}
                        >
                            {/* Main Focus */}
                            <Stack spacing={0.5} mb={3}>
                                <Typography
                                    variant="body2"
                                    sx={{ color: "#6b7280", letterSpacing: 0.5 }}
                                >
                                    Outstanding Amount
                                </Typography>

                                <Typography
                                    variant="h4"
                                    sx={{ fontWeight: 700, color: "#111827" }}
                                >
                                    ₹&nbsp;{summary.remainingAmount}
                                </Typography>
                            </Stack>

                            {/* Secondary Stats */}
                            <Grid container spacing={2}>
                                <Grid item xs={6} sm={3}>
                                    <Typography variant="caption" color="text.secondary">
                                        Total Fee
                                    </Typography>
                                    <Typography fontWeight={600}>
                                        ₹&nbsp;{summary.totalFee}
                                    </Typography>
                                </Grid>

                                <Grid item xs={6} sm={3}>
                                    <Typography variant="caption" color="text.secondary">
                                        Paid Till Date
                                    </Typography>
                                    <Typography fontWeight={600} style={{ color: "#059669" }} >
                                        ₹&nbsp;{summary.totalPaid}
                                    </Typography>
                                </Grid>

                                <Grid item xs={6} sm={3}>
                                    <Typography variant="caption" color="text.secondary">
                                        Expected by Now (slab-wise)
                                    </Typography>
                                    <Typography fontWeight={600}>
                                        ₹&nbsp;{summary.expectedByNow}
                                    </Typography>
                                </Grid>

                                <Grid item xs={6} sm={3}>
                                    <Typography variant="caption" color="text.secondary">
                                        Status
                                    </Typography>
                                    <Typography
                                        fontWeight={600}
                                        sx={{
                                            color:
                                                summary.overdueAmount > 0
                                                    ? "#dc2626"
                                                    : "#16a34a",
                                        }}
                                    >
                                        {summary.overdueAmount > 0 ? "Overdue" : "On Track"}
                                    </Typography>
                                </Grid>
                            </Grid>

                            {/* Divider */}
                            <Divider sx={{ my: 3 }} />

                            {/* Timeline Section */}
                            <Stack spacing={2} sx={{ mt: 1.5, mr: 60 }}>
                                {/* Next Due */}
                                {summary.nextExpectedAmount > 0 && (
                                    <Box
                                        sx={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            px: 1,
                                            py: 1,
                                            borderRadius: 2,
                                            backgroundColor: "#fafafa",
                                        }}
                                    >
                                        <Box>
                                            <Typography variant="body2" fontWeight={500}>
                                                Next Payment Due
                                            </Typography>

                                            {summary.nextExpectedDate && (
                                                <Typography
                                                    variant="caption"
                                                    color="text.secondary"
                                                    sx={{ display: "block", mt: 0.3 }}
                                                >
                                                    {new Date(summary?.nextExpectedDate).toLocaleDateString(
                                                        "en-GB",
                                                        {
                                                            day: "2-digit",
                                                            month: "short",
                                                            year: "numeric",
                                                        }
                                                    )}
                                                </Typography>
                                            )}
                                        </Box>

                                        <Typography
                                            fontWeight={700}
                                            sx={{
                                                color: "#de2668",
                                                fontSize: "0.95rem",
                                            }}
                                        >
                                            ₹ {summary.nextExpectedAmount}
                                        </Typography>
                                    </Box>
                                )}

                                {/* Overdue */}
                                {summary.overdueAmount > 0 && (
                                    <Box
                                        sx={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            px: 1,
                                            py: 1,
                                            borderRadius: 2,
                                            backgroundColor: "#fff1f2",
                                        }}
                                    >
                                        <Typography fontWeight={500} color="#dc2626">
                                            Overdue Amount
                                        </Typography>

                                        <Typography fontWeight={700} color="#dc2626">
                                            ₹ {summary.overdueAmount}
                                        </Typography>
                                    </Box>
                                )}
                            </Stack>

                        </Box>
                    </GridItem>


                    {/* Amount */}
                    <GridItem xs={12} sm={6}>
                        <CustomInput
                            labelText="Amount"
                            id="amount"
                            formControlProps={{
                                fullWidth: true,
                            }}
                            inputProps={{
                                type: "number",
                                name: "amount",
                                value: paymentData.amount,
                                onChange: handleChange,
                                required: true,
                            }}
                        />

                        {/* <TextField
                            fullWidth
                            label="Amount"
                            type="number"
                            name="amount"
                            value={paymentData.amount}
                            onChange={handleChange}
                            required
                        /> */}
                    </GridItem>

                    {/* Payment Mode */}
                    <GridItem xs={12} sm={6}>
                        <CustomSelect
                            label="Payment Mode"
                            id="paymentMode"
                            name="paymentMode"
                            options={paymentModeOptions}
                            value={paymentData.paymentMode}
                            setvalue={(v) =>
                                setPaymentData(prev => ({
                                    ...prev,
                                    paymentMode: v,
                                }))
                            }
                        />
                    </GridItem>

                    {/* <GridItem xs={12} sm={6}>
                        <TextField
                            fullWidth
                            label="Payment Mode"
                            name="paymentMode"
                            value={paymentData.paymentMode}
                            onChange={handleChange}
                        />
                    </GridItem> */}

                    {/* Transaction ID */}
                    <GridItem xs={12} sm={6}>
                        <TextField
                            fullWidth
                            label={getTransactionLabel()}  //"Transaction ID (Optional)"
                            name="transactionId"
                            value={paymentData.transactionId}
                            onChange={handleChange}
                        />
                    </GridItem>

                    {/* Payment Date */}
                    <GridItem xs={12} sm={6}>
                        <TextField
                            fullWidth
                            type="date"
                            label="Payment Date"
                            name="paymentDate"
                            InputLabelProps={{ shrink: true }}
                            value={paymentData.paymentDate}
                            onChange={handleChange}
                            inputProps={{
                                max: today,
                            }}
                        />
                    </GridItem>

                </GridContainer>

                <Button
                    color="rose"
                    style={{ float: "right", marginTop: 20 }}
                    onClick={handleSubmit}
                >
                    Add Payment
                </Button>
            </CardBody>

            <Snackbar
                open={open}
                autoHideDuration={2000}
                onClose={() => setOpen(false)}
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            >
                <Alert severity={severity}>{message}</Alert>
            </Snackbar>
        </Card >
    );
}
